import { render, staticRenderFns } from "./InviteLink.vue?vue&type=template&id=1c62874d&scoped=true"
import script from "./InviteLink.vue?vue&type=script&lang=js"
export * from "./InviteLink.vue?vue&type=script&lang=js"
import style0 from "./InviteLink.vue?vue&type=style&index=0&id=1c62874d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c62874d",
  null
  
)

export default component.exports